import React from 'react';

// eslint-disable-next-line
const Icon = ({ glyph, width = '', height = '', className = 'icon' }) => {
  return (
    <svg className={className} width={width} height={height}>
      <use xlinkHref={glyph} />
    </svg>
  );
};

export default Icon;



// WEBPACK FOOTER //
// ./client/js/components/shared/Icon.js